package com.yendo.mx.utils

import androidx.compose.runtime.Composable
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.initialize
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow

fun inicializarFirebaseWeb() {
    try {
        Firebase.initialize(
            options = FirebaseOptions(
                apiKey = "AIzaSyC3TrASqEP0QgneV_J82td75saiTT_opaw",
                applicationId = "1:589218452518:web:5ec539a97fe9439eaa42e7",
                projectId = "yendo-mx",
                authDomain = "yendo-mx.firebaseapp.com",
                storageBucket = "yendo-mx.firebasestorage.app",
                databaseUrl = "https://yendo-mx-default-rtdb.firebaseio.com"
            )
        )
        println("YENDO_WEB: Firebase inicializado correctamente con authDomain.")
    } catch (e: Exception) {
        println("YENDO_WEB: Nota sobre Firebase Init -> ${e.message}")
    }
}

actual fun esAndroid(): Boolean = false

actual fun getAhora(): Long = kotlin.js.Date.now().toLong()

actual fun obtenerTokenFirebase(onToken: (String) -> Unit) {
    onToken("")
}

@Composable
actual fun SolicitarPermisoNotificaciones() {}

@Composable
actual fun verificarPermisoNotificaciones(onResultado: (Boolean) -> Unit) {
    onResultado(true)
}

@Composable
actual fun abrirConfiguracionApp(): () -> Unit = {}

@Composable
actual fun observarConexionInternet(): StateFlow<Boolean> {
    return MutableStateFlow(true)
}

actual fun obtenerIdDispositivo(): String = "web-browser-device"

actual fun obtenerMetadataDispositivo(): Map<String, String> = mapOf(
    "platform" to "web",
    "os" to "browser",
    "version_code" to "999999"
)
